<template>
	<div>
		<kendo-dropdownlist
			ref="dropdown"
			v-model="selectedId"
			:data-source="items"
			:data-text-field="'text'"
			:data-value-field="'id'"
			:optionLabel="$t('choose')"
			@change="inputChanged"
			:filter="filterPattern"
			:name="'dropdown' + _uid"
			:data-vv-as="fieldName"
            :height="height"
			:footer-template="nomDropdownSettings.showFooterTemplate ? footerTemplate : ''"
			v-validate="required ? 'required' : ''"
			style="width: 100%;"
			:disabled="disabled"
		></kendo-dropdownlist>
		<span class="text-danger col-12" v-if="errors.has('dropdown' + _uid)">{{ errors.first('dropdown' + _uid) }}</span>

		<DropdownSettings
			:filterPattern.sync="filterPattern"
			:show.sync="showSettings"
		></DropdownSettings>
</div>
</template>

<script>
import Vue from "vue";
import FooterTemplate from "../../components/grid/NomenclatureDropdownFooterTemplate";
import DropdownSettings from "../../components/common/DropdownSettings";
import { mapGetters } from "vuex";

export default {
	inject: ['$validator'],
	components: {
        DropdownSettings,
    },
	props: {
		items: {
			type: Array,
			required: true
		},
		value: [String, Number],
		fieldName: String,
		required: {
			type: Boolean,
			default: false
		},
		nullable: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
        height: {
            type: Number,
            default: 400, // 200 - Default value for Kendo DropdownList
        }
	},
	data() {
		return {
			selectedId: this.value,
			defaultItem: null,
			showSettings: false,
            filterPattern: "",
		};
	},
	mounted() {
		this.filterPattern = this.nomDropdownSettings.defaultFilterPattern;

		if (!this.nullable && this.items.length) {
			this.setDefaultValue();
		}
	},
	methods: {
		inputChanged(event) {
			this.$emit('input', event.sender.value());
		},
		setDefaultValue() {
			this.$refs.dropdown.kendoWidget().select(1);
			this.$emit('input', this.items[0].id);
		},
		footerTemplate: function (e) {
            return {
                template: Vue.component(FooterTemplate.name, FooterTemplate),
                templateArgs: {
                    ...e,
                    btns: [
                        {
                            name: "staticDropdownSettings",
                            text: this.$t("buttons.settings.btnText"),
                            tooltip: this.$t("buttons.settings.btnText"),
                            class: "btn btn-secondary",
                            icon: "fas fa-cog",
                            show: this.nomDropdownSettings.showSettings,
                            clickHandler: () => {
                                this.showSettings = true;
                            },
                        },
                    ],
                },
            };
        },
	},
	computed: {
        ...mapGetters(['nomDropdownSettings']),
    },
	watch: {
		value: function(newValue, oldValue) {
			this.selectedId = newValue;
		},
		items: function(val) {
			if (!this.nullable && !this.value && this.items.length) {
				this.setDefaultValue();
			}
		}
	}
};
</script>
